import React, { useState, useEffect } from 'react'
import CurrencyInput from 'react-currency-input-field'
import Slider from 'react-input-slider'
import * as styles from './InputFormCenter.module.scss'
import { useCalc } from '../../context/CalcContext'
import { default as MUSlider } from '@mui/material/Slider'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import {
  scale,
  descale,
  numFormatter,
  numDeformatter
} from '../../util/scaleHelper'
import { mrrScale, meScale, momScale, cbScale } from '../../util/scales'

const theme = createTheme({
  palette: {
    primary: {
      main: '#0a8973'
    },
    secondary: {
      main: '#0a8973'
    }
  }
})

const InputFormCenter = () => {
  const [errorMessage, setErrorMessage] = useState('')
  const { mrr, setMrr, mom, setMom, me, setMe, setGm, cb, setCb } = useCalc()
  const [localMrr, setLocalMrr] = useState(100)
  const [localMe, setLocalMe] = useState(116)
  const [localMom, setLocalMom] = useState(300)
  const [localCb, setLocalCb] = useState(700)

  useEffect(() => {
    setMrr(scale(localMrr, mrrScale))
  }, [localMrr])
  useEffect(() => {
    setMe(scale(localMe, meScale))
  }, [localMe])
  useEffect(() => {
    setMom(scale(localMom, momScale) / 100)
  }, [localMom])
  useEffect(() => {
    setCb(scale(localCb, cbScale))
  }, [localCb])
  // console.log('localMe', localMe)
  return (
    <ThemeProvider theme={theme}>
      <div style={{ margin: 'auto', width: '100%' }}>
        <div className={styles.inputFormWrap}>
          {/* <h5>Fill in your metrics</h5> */}
          <form className={styles.inputForm}>
            {/*<div className={styles.formCol}>
          <div className={styles.formGroup}>
            <h3>Fill in your metrics</h3>
             <a href="#fejron-calc-growth" className={styles.buttonCalculator}>
              See your potential
            </a>
          </div>
        </div>*/}

            <label htmlFor="fejron-calc-mrr">Monthly Recurring Revenue</label>
            <div className={styles.formGroup}>
              <MUSlider
                value={localMrr}
                min={0}
                max={200}
                step={5}
                scale={(v) => scale(v, mrrScale)}
                valueLabelFormat={numFormatter}
                onChange={(e, v) => {
                  if (typeof v === 'number') {
                    setLocalMrr(v)
                  }
                }}
                valueLabelDisplay="off"
                aria-labelledby="non-linear-slider"
                className={styles.MuiSlider}
                color="secondary"
              />

              <input
                inputMode="numeric"
                type="text"
                value={'€ ' + numFormatter(scale(localMrr, mrrScale))}
                onChange={(e) => {
                  const value = descale(
                    numDeformatter(e.target.value),
                    mrrScale
                  )
                  setLocalMrr(value)
                }}
              />
            </div>
            <div className="invalid-feedback">{errorMessage || ''}</div>
            <label htmlFor="fejorn-calc-mrr">Monthly expenses</label>
            <div className={styles.formGroup}>
              <MUSlider
                value={localMe}
                min={0}
                max={240}
                step={1}
                scale={(v) => scale(v, meScale)}
                valueLabelFormat={numFormatter}
                onChange={(e, v) => {
                  if (typeof v === 'number') {
                    setLocalMe(v)
                  }
                }}
                valueLabelDisplay="off"
                aria-labelledby="non-linear-slider"
                className={styles.MuiSlider}
              />
              <input
                inputMode="numeric"
                type="text"
                value={'€ ' + numFormatter(scale(localMe, meScale))}
                onChange={(e) => {
                  const val = e.target.value
                  const deformatted = numDeformatter(val)
                  if (typeof deformatted === 'number' && deformatted > 0) {
                    const value = descale(deformatted, meScale)
                    setLocalMe(value)
                  }
                }}
              />
            </div>

            <label htmlFor="fejorn-calc-mom">MoM growth rate</label>
            <div className={styles.formGroup}>
              <MUSlider
                value={localMom}
                min={0}
                max={800}
                step={50}
                scale={(v) => scale(v, momScale)}
                valueLabelFormat={(v) => parseFloat(v).toFixed(1)}
                onChange={(e, v) => {
                  if (typeof v === 'number') {
                    setLocalMom(v)
                  }
                }}
                valueLabelDisplay="off"
                aria-labelledby="non-linear-slider"
                className={styles.MuiSlider}
              />
              <input
                inputMode="numeric"
                type="text"
                value={scale(localMom, momScale).toFixed(1) + '%'}
                onChange={(e) => {
                  const val = e.target.value
                  const deformatted = parseFloat(val)
                  if (typeof deformatted === 'number' && deformatted > 0) {
                    const value = descale(deformatted, momScale)
                    setLocalMom(value)
                  }
                }}
              />
            </div>

            <label htmlFor="fejorn-calc-mrr" style={{ display: 'none' }}>
              Gross margin
            </label>
            <div className={styles.formGroup} style={{ display: 'none' }}>
              <CurrencyInput
                id="fejorn-calc-gm"
                name="gm"
                placeholder="Enter your gross margin"
                defaultValue={80}
                suffix="%"
                decimalsLimit={2}
                onValueChange={(value) => setGm(parseFloat(value) / 100)}
              />
              {/* <div className="invalid-feedback">{errorMessage || ''}</div> */}
            </div>
            <label htmlFor="fejorn-calc-mrr">Current Cash balance</label>
            <div className={styles.formGroup}>
              <MUSlider
                value={localCb}
                min={0}
                max={1500}
                step={50}
                scale={(v) => scale(v, cbScale)}
                valueLabelFormat={numFormatter}
                onChange={(e, v) => {
                  if (typeof v === 'number') {
                    setLocalCb(v)
                  }
                }}
                valueLabelDisplay="off"
                aria-labelledby="non-linear-slider"
                className={styles.MuiSlider}
              />
              <input
                inputMode="numeric"
                type="text"
                value={'€ ' + numFormatter(scale(localCb, cbScale))}
                onChange={(e) => {
                  const val = e.target.value
                  const deformatted = numDeformatter(val)
                  if (typeof deformatted === 'number' && deformatted > 0) {
                    const value = descale(deformatted, cbScale)
                    setLocalCb(value)
                  }
                }}
              />
            </div>
          </form>
        </div>
      </div>
    </ThemeProvider>
  )
}

export default InputFormCenter
